var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
// css
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/common.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Aif&PmsSidebar.scss";
import "@frameworks/salesjourney/stylesheets/components/Features/PlaceOrder/MFPlaceOrderTable.scss";
import "./redeem-edit.scss";
// components
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import GenericSidebar from "@frameworks/shared-library/components/GenericSidebar";
import RedeemEditFooter from "./RedeemEditFooter";
import RedeemEditBody from "./RedeemEditBody";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import actions from "@mainDi/features/AIF-PMS/actions";
import { changeInRupeeFormat } from "@frameworks/pmsjourney/utils";
import GenericToast from "@frameworks/shared-library/components/GenericToast";
var RedeemEdit = function (_a) {
    //
    var _b, _c;
    var visible = _a.visible, setVisible = _a.setVisible, onSideBarClose = _a.onSideBarClose;
    var cActions = actions();
    var _d = useSelector(function (state) { return state.markets.qualityCheck; }), pendingTransactionById = _d.pendingTransactionById, documentList = _d.documentList;
    var _e = useSelector(function (state) { return state.markets.AifPms; }), clientDetails = _e.clientDetails, transactionId = _e.transactionId, watchListData = _e.watchListData;
    var _f = useSelector(function (state) { return state.markets.payment; }), redeem = _f.redeem, uploadDeclaration = _f.uploadDeclaration;
    var _g = __read(useState(false), 2), loading = _g[0], setLoading = _g[1];
    var _h = __read(useState(""), 2), message = _h[0], setMessage = _h[1];
    var _j = __read(useState(false), 2), showToast = _j[0], setShowToast = _j[1];
    useEffect(function () {
        if (pendingTransactionById !== null && (pendingTransactionById === null || pendingTransactionById === void 0 ? void 0 : pendingTransactionById.data)) {
            var _a = pendingTransactionById === null || pendingTransactionById === void 0 ? void 0 : pendingTransactionById.data, pan = _a.pan, clientName = _a.clientName, uccCode = _a.uccCode, trxId = _a.trxId, redeemReason = _a.redeemReason, amount = _a.amount, folioNumber = _a.folioNumber, schemeId = _a.schemeId, categoryCode = _a.categoryCode;
            aifPmsDi.aifPms.updateSubCategoryId(categoryCode);
            aifPmsDi.aifPms.updateTransactionId(trxId);
            aifPmsDi.aifPms.updateWatchListData(__assign(__assign({}, watchListData), { schemeId: schemeId }));
            aifPmsDi.aifPms.updateClientDetails(__assign(__assign({}, clientDetails), { clientName: clientName, accountCode: "", pan: pan, ucccode: uccCode, uniqueCode: uccCode, clienttier: "" }));
            aifPmsDi.payment.updateRedeemValues(__assign(__assign({}, redeem), { redeemAmount: String(changeInRupeeFormat(String(amount))), reason: redeemReason, folio: folioNumber }));
        }
    }, [pendingTransactionById === null || pendingTransactionById === void 0 ? void 0 : pendingTransactionById.data]);
    useEffect(function () {
        var _a;
        if (documentList === null || documentList === void 0 ? void 0 : documentList.data) {
            var files = (_a = documentList.data) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                return __assign(__assign({}, item), { file: {
                        name: item.filename,
                    }, imageUrl: "", progress: 100 });
            });
            aifPmsDi.payment.updateUploadDeclarationValueProp(files);
        }
    }, [documentList === null || documentList === void 0 ? void 0 : documentList.data]);
    var onClickCancel = function () {
        setVisible(false);
        cActions.qualityCheck.pendingTransactionById(null);
        cActions.payment.resetValue();
        aifPmsDi.payment.updateRedeemValues({
            redeemAmount: "",
            reason: "",
            folio: "",
            totalqty: 0,
            marketvalue: 0,
        });
    };
    var onClickContinue = function () {
        var _a;
        setLoading(true);
        aifPmsDi.qualityCheck
            .modifyTransaction({
            trxId: transactionId,
            updatedBy: "",
            trxAmount: Number((_a = redeem.redeemAmount) === null || _a === void 0 ? void 0 : _a.split(",").join("")),
            trxQuantity: redeem.approxUnit,
            formNumber: "",
            paymentMode: "",
            bankName: "",
            chequeNumber: null,
            chequeDate: null,
            rtgsNumber: "",
            setupFeePercent: 0,
            folioNumber: redeem.folio,
            redeemReason: redeem.reason,
            IsEditable: true,
        })
            .then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoading(false);
                        if (!response.data) return [3 /*break*/, 2];
                        setVisible(false);
                        setMessage(response.message);
                        setShowToast(true);
                        return [4 /*yield*/, aifPmsDi.orderBook.orderbooklist({
                                CategoryCode: (_a = pendingTransactionById === null || pendingTransactionById === void 0 ? void 0 : pendingTransactionById.data) === null || _a === void 0 ? void 0 : _a.categoryCode,
                                page: 1,
                                pageSize: 2000,
                            })];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); })
            .catch(function (error) {
            setLoading(false);
        });
    };
    var disabled = useMemo(function () {
        return ((redeem === null || redeem === void 0 ? void 0 : redeem.folio) === "" ||
            (redeem === null || redeem === void 0 ? void 0 : redeem.reason) === "" ||
            redeem.termAccepted == false ||
            uploadDeclaration.length === 0);
    }, [redeem === null || redeem === void 0 ? void 0 : redeem.folio, redeem === null || redeem === void 0 ? void 0 : redeem.reason, redeem.termAccepted, uploadDeclaration]);
    return (React.createElement(React.Fragment, null,
        React.createElement(GenericSidebar, { parentClassname: "primary-order-book-sidebar-container primary-aif-pms-sidebar-container d-flex flex-column", header: React.createElement("div", { className: "order-book-sidebar-header" },
                React.createElement("div", { className: "read-more-tooltip align-items-center" },
                    React.createElement(GenericSchemeName, { name: (_b = pendingTransactionById === null || pendingTransactionById === void 0 ? void 0 : pendingTransactionById.data) === null || _b === void 0 ? void 0 : _b.schemeName, subText1: (_c = pendingTransactionById === null || pendingTransactionById === void 0 ? void 0 : pendingTransactionById.data) === null || _c === void 0 ? void 0 : _c.category, showImage: true, maxWidth: 335 }))), body: React.createElement(React.Fragment, null,
                React.createElement(RedeemEditBody, { loading: loading }),
                showToast && (React.createElement(React.Fragment, null,
                    React.createElement(GenericToast, { message: React.createElement("div", { className: "d-flex align-items-center gap-2" },
                            React.createElement("span", { className: "edel-icon-tick bg-lime-green rounded-circle" }),
                            React.createElement("span", null, message)), showHeader: false, position: "bottom-center", showCloseButtonInBody: true, theme: "dark-slate-blue", show: showToast, setClose: function () {
                            setShowToast(false);
                        }, autohide: true, parentClassName: "product-bouquet-toast" })))), footer: React.createElement(RedeemEditFooter, { onClickCancel: onClickCancel, onClickContinue: onClickContinue, disabled: disabled || loading }), openKey: visible, setOpenKey: setVisible, arrowClose: true, delay: 10, blurBackground: true, parentIcon: "edel-icon-close", onSideBarClose: onSideBarClose })));
};
export default RedeemEdit;
